import { IconDownload } from '@iwoca/icons';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import {
    RequirementItem,
    TFundingRequirementStatus
} from '../RequirementsList/RequirementItem/RequirementItem';
import { useGetDocument } from '../SignDocumentStep/useGetDocument';

const REFINANCING_SIDE_LETTER_PATH =
    '/funding-requirements/sign-refinancing-side-letter';

type TRefinancingSideLetterStepProps = { status: TFundingRequirementStatus };

export const RefinancingSideLetterStep = ({
    status
}: TRefinancingSideLetterStepProps) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.refinancing_side_letter_step.list_title"
                    defaultMessage="Read and sign your refinancing side letter"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements.estimated_time"
                    defaultMessage="~ {minutes} mins"
                    values={{ minutes: 2 }}
                />
            }
            href={REFINANCING_SIDE_LETTER_PATH}
            status={status}
            completedView={<RefinancingSideLetterCompletedView />}
        />
    );
};

const RefinancingSideLetterCompletedView = () => {
    const { downloadUrl, isLoading } = useGetDocument(
        'refinancing_side_letter'
    );

    return (
        <div className="flex grow items-center justify-between gap-l pr-0 min-m:pr-s">
            <Text className="text-m font-med text-primary-10">
                <FormattedMessage
                    id="_.funding_requirements.refinancing_side_letter_step.list_title"
                    defaultMessage="Read and sign your refinancing side letter"
                />
            </Text>
            {!isLoading && (
                <a
                    href={downloadUrl}
                    download
                    aria-label="Download refinancing side letter"
                    className="text-l text-primary-40"
                >
                    <IconDownload />
                </a>
            )}
        </div>
    );
};
